import { api } from '$shared/api';

/**
 * Toggle a track's favorite (saved) state. POST if currently not favorited,
 * DELETE if currently favorited. Returns the new state on success; throws on
 * API error so callers can revert their optimistic UI.
 *
 * One unified `track` entity now (Track Unification): a catalog track id and a
 * duel-submission track id share one id-space, so there is a single favorite
 * endpoint — `/tracks/{id}/favorite`. Pulled out of HeartButton.svelte so the
 * behavior is directly Vitest-testable without a Svelte render harness.
 */
export async function toggleFavorite(trackId: number, currentState: boolean): Promise<boolean> {
  if (currentState) {
    await api.delete(`/tracks/${trackId}/favorite`);
    return false;
  }
  await api.post(`/tracks/${trackId}/favorite`);
  return true;
}
